<template>
  <div class="auth-control has-toggle">
    <input
      :id="id"
      ref="input"
      :value="value"
      :type="revealed ? 'text' : 'password'"
      :autocomplete="autocomplete"
      :class="{ 'has-error': hasError }"
      :aria-invalid="hasError ? 'true' : 'false'"
      :aria-describedby="describedby"
      :disabled="disabled"
      class="auth-input"
      name="password"
      @input="$emit('input', $event.target.value)"
    >
    <button
      type="button"
      class="auth-reveal"
      :aria-label="revealed ? 'Hide password' : 'Show password'"
      @click="toggle"
    >
      <svg
        v-if="revealed"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M10.6 5.1A10 10 0 0 1 12 5c6.4 0 10 7 10 7a17 17 0 0 1-2.6 3.4M6.2 6.2C3.6 7.9 2 12 2 12s3.6 7 10 7c1.9 0 3.5-.6 4.9-1.4" />
        <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
        <path d="M3 3l18 18" />
      </svg>
      <svg
        v-else
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" />
        <circle
          cx="12"
          cy="12"
          r="3"
        />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'AuthPasswordInput',

  props: {
    value: { type: String, default: '' },
    id: { type: String, default: 'password' },
    autocomplete: { type: String, default: 'current-password' },
    hasError: { type: Boolean, default: false },
    describedby: { type: String, default: null },
    disabled: { type: Boolean, default: false }
  },

  data () {
    return {
      revealed: false
    }
  },

  methods: {
    toggle () {
      const input = this.$refs.input
      const position = input.selectionStart
      this.revealed = !this.revealed
      this.$nextTick(() => {
        input.focus()
        try {
          input.setSelectionRange(position, position)
        } catch (e) {}
      })
    },

    focus () {
      this.$refs.input.focus()
    }
  }
}
</script>
